import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import { StyledDialog as BaseStyledDialog } from 'app/components/StyledDialog/styles';
import { dialogPaper } from 'app/components/DialogFrame/styles';

export {
  Head,
  Title,
  Description,
  Body,
  Foot,
  ResultState,
  ResultIcon,
  ResultTitle,
  ResultMessage,
} from 'app/components/DialogFrame/styles';
export { SecondaryButton, PrimaryButton } from 'app/components/DialogFooterButtons/styles';

const { gray, red } = colors.designSystem;

export const StyledDialog = styled(BaseStyledDialog)`
  .MuiDialog-paper {
    width: 460px;
    ${dialogPaper}
  }
`;

export const CloseButton = styled(IconButton)`
  color: ${gray[700]} !important;
  padding: 4px !important;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: ${gray[800]};
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  height: 44px;
  padding: 0 14px;
  font-size: 14px;
  font-family: inherit;
  color: ${gray[800]};
  background: ${gray[0]};
  border: 2px solid ${({ $hasError }) => ($hasError ? red[500] : gray[400])};
  border-radius: 10px;

  @media (prefers-reduced-motion: no-preference) {
    transition: border-color 120ms ease;
  }

  &:focus-visible {
    border-color: ${({ $hasError }) => ($hasError ? red[500] : gray[700])};
  }
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ErrorNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${gray[100]};
  font-size: 13px;
  color: ${gray[800]};
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: ${red[500]};
  }
`;

export const HelperNote = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  color: ${gray[600]};
  line-height: 1.5;
`;

export const CouponComparison = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${gray[700]};
  line-height: 1.5;

  strong {
    color: ${gray[950]};
    font-weight: 600;
  }
`;
